/* eslint-disable no-unused-vars */
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function UnNumberedList({ items }) {
  return (
    <MKBox display="flex" flexDirection="column">
      {items.map((item, index) => (
        <MKBox key={index} display="flex" flexDirection="row" alignItems="center">
          {/* <MKBox display="flex">
            <Icon fontSize="small">check_small</Icon>
          </MKBox> */}
          <MKBox component="ul" display="flex" pl={5}>
            <MKTypography component="li" variant="body1" color="text" pl={2}>
              {item}
            </MKTypography>
          </MKBox>
        </MKBox>
      ))}
    </MKBox>
  );
}
UnNumberedList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default UnNumberedList;
